import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { ChatMessageID } from '../../types'
import ChatError from '../../common/ChatError'
import { API_RATE_ENDPOINT } from './const'
import { RateMessageParams, SharedAssistantState } from './types'
import { trackUserReaction } from '../../common/pendoTracking'

export default async function rateMessage<T extends SharedAssistantState>(
  messageID: ChatMessageID,
  like: boolean | null,
  { assistantState, update, awaitContext, debugName = 'ChatAssistant' }: RateMessageParams<T>
): Promise<ChatError | undefined> {
  if ('development' === process.env.NODE_ENV) {
    // eslint-disable-next-line no-console
    console.debug(`${debugName}: rateMessage`, messageID, like)
  }

  try {
    if (awaitContext) {
      const rateContext = await awaitContext({ assistantState }).catch(error => {
        throw error instanceof ChatError ? error : new ChatError(String(error))
      })

      const rateParams = {
        domain: assistantState.domain,
        context: rateContext,
        like
      }

      const rateResponse = await railsPostFetch(
        API_RATE_ENDPOINT.URL.replace('{chatID}', String(assistantState.chatID)).replace(
          '{messageID}',
          String(messageID)
        ),
        {
          method: API_RATE_ENDPOINT.method,
          body: JSON.stringify(rateParams)
        }
      )

      if (200 !== rateResponse.status) {
        throw new ChatError('Failed to rate message')
      }
    }

    const message = assistantState.messages.find(msg => msg.id === messageID)
    if (message) {
      message.like = like
      trackUserReaction({
        domain: assistantState.domain,
        conversationId: assistantState.chatID,
        messageId: messageID,
        like
      })
      update()

      if ('development' === process.env.NODE_ENV) {
        // eslint-disable-next-line no-console
        console.debug(`${debugName}: rateMessage done`, messageID, like)
      }
    }
  } catch (error) {
    if ('development' === process.env.NODE_ENV) {
      // eslint-disable-next-line no-console
      console.error(`${debugName}: rateMessage error`, error, (error as ChatError)?.payload)
    }

    return error instanceof ChatError ? error : new ChatError(error instanceof Error ? error.message : 'Unknown error')
  }

  return undefined
}
